import { d as s } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var _ = {
  name: "tzm-latn",
  weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
  months: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
  weekStart: 6,
  weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
  monthsShort: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
  weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
  ordinal: function(a) {
    return a;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm"
  },
  relativeTime: {
    future: "dadkh s yan %s",
    past: "yan %s",
    s: "imik",
    m: "minuḍ",
    mm: "%d minuḍ",
    h: "saɛa",
    hh: "%d tassaɛin",
    d: "ass",
    dd: "%d ossan",
    M: "ayowr",
    MM: "%d iyyirn",
    y: "asgas",
    yy: "%d isgasn"
  }
};
s.locale(_, null, !0);
export {
  _ as default
};
